import { Component, OnInit, ViewChild } from '@angular/core'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AddChildProfileComponent } from '@se-po/shared-ui-add-child-profile'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { SeFeFormService } from 'se-fe-form-service'

import { ActivatedRoute } from '@angular/router'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { ChildInfoSubmitter } from './child-info-submit.service'

@Component({
  selector: 'se-po-household-setup-feature-child-info',
  templateUrl: './child-info.component.html',
  styleUrls: ['./child-info.component.scss'],
})
export class ChildInfoComponent implements OnInit {
  @ViewChild('childInfo') public childInfo: AddChildProfileComponent

  public optionalFields: string[]
  public ready = false
  private readonly app = 'SingleSignOn'
  private readonly page = 'HouseholdSetup'
  private readonly label = 'ChildInfo'

  constructor(
    private analyticsService: AnalyticsService,
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: ChildInfoSubmitter,
    private formService: SeFeFormService,
    private route: ActivatedRoute
  ) { }

  public ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.context === 'membership') {
        this.optionalFields = ['gradYear']
      }
      this.ready = true
      this.setupBarService.percentComplete = 25
    })
    this.analyticsService.pageView(this.app, this.page, this.label)
  }

  public submit(): void {
    if (!this.formService.isValid(this.childInfo.form)) return

    this.submitter.submit(this.childInfo.value, this.store)
  }
}
